"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var leaflet_1 = require("leaflet");
var map_component_1 = require("./map.component");
var marker_directive_1 = require("./marker.directive");
// Content-Child imports
var popup_directive_1 = require("./popup.directive");
var tooltip_directive_1 = require("./tooltip.directive");
var GeoJSONDirective = /** @class */ (function (_super) {
    __extends(GeoJSONDirective, _super);
    function GeoJSONDirective(mapComponent) {
        var _this = _super.call(this, { features: [], type: 'FeatureCollection' }, {
            filter: function (feature) {
                return _this.filterFeatures(feature);
            },
            onEachFeature: function (feature, layer) {
                _this.onEachFeatureEvent.emit({ feature: feature, layer: layer });
            },
            pointToLayer: function (geoJSON, latLng) {
                return _this.pointToLayer(geoJSON, latLng);
            },
            style: function (geoJSON) {
                return _this.styler(geoJSON, _this.defaultStyle);
            },
        }) || this;
        /* tslint:disable:max-line-length */
        _this.dataChange = new core_1.EventEmitter();
        /* tslint:enable */
        _this.addEvent = new core_1.EventEmitter();
        _this.removeEvent = new core_1.EventEmitter();
        _this.popupopenEvent = new core_1.EventEmitter();
        _this.popupcloseEvent = new core_1.EventEmitter();
        _this.tooltipopenEvent = new core_1.EventEmitter();
        _this.tooltipcloseEvent = new core_1.EventEmitter();
        _this.clickEvent = new core_1.EventEmitter();
        _this.dbclickEvent = new core_1.EventEmitter();
        _this.mousedownEvent = new core_1.EventEmitter();
        _this.mouseoverEvent = new core_1.EventEmitter();
        _this.mouseoutEvent = new core_1.EventEmitter();
        _this.contextmenuEvent = new core_1.EventEmitter();
        /* tslint:disable:max-line-length */
        _this.onEachFeatureEvent = new core_1.EventEmitter();
        /* tslint:enable */
        _this.defaultStyle = {};
        _this.initialized = false;
        _this.mapComponent = mapComponent;
        mapComponent.addLayer(_this);
        // Events
        _this.on('add', function (event) {
            _this.addEvent.emit(event);
        });
        _this.on('remove', function (event) {
            _this.removeEvent.emit(event);
        });
        _this.on('popupopen', function (event) {
            _this.popupopenEvent.emit(event);
        });
        _this.on('popupclose', function (event) {
            _this.popupcloseEvent.emit(event);
        });
        _this.on('tooltipopen', function (event) {
            _this.tooltipopenEvent.emit(event);
        });
        _this.on('tooltipclose', function (event) {
            _this.tooltipcloseEvent.emit(event);
        });
        _this.on('click', function (event) {
            _this.clickEvent.emit(event);
        });
        _this.on('dbclick', function (event) {
            _this.dbclickEvent.emit(event);
        });
        _this.on('mousedown', function (event) {
            _this.mousedownEvent.emit(event);
        });
        _this.on('mouseover', function (event) {
            _this.mouseoverEvent.emit(event);
        });
        _this.on('mouseout', function (event) {
            _this.mouseoutEvent.emit(event);
        });
        _this.on('contextmenu', function (event) {
            _this.contextmenuEvent.emit(event);
        });
        return _this;
    }
    GeoJSONDirective.prototype.ngAfterViewInit = function () {
        this.initialized = true;
        if (this.popupDirective) {
            this.bindPopup(this.popupDirective);
        }
        if (this.tooltipDirective) {
            this.bindTooltip(this.tooltipDirective);
        }
    };
    GeoJSONDirective.prototype.ngOnDestroy = function () {
        this.removeFrom(this._map);
    };
    GeoJSONDirective.prototype.pointToLayer = function (geoJSON, latLng) {
        var marker = new marker_directive_1.MarkerDirective(this.mapComponent);
        marker.setLatLng(latLng);
        return marker;
    };
    GeoJSONDirective.prototype.styler = function (geoJSON, defaultStyle) {
        return defaultStyle;
    };
    GeoJSONDirective.prototype.filterFeatures = function (geoJSON) {
        return true;
    };
    GeoJSONDirective.prototype.addData = function (data) {
        var returnValue = _super.prototype.addData.call(this, data);
        if (!this.initialized) {
            return returnValue;
        }
        this.dataChange.emit(this.toGeoJSON());
        return returnValue;
    };
    GeoJSONDirective.prototype.setData = function (val) {
        _super.prototype.clearLayers.call(this);
        _super.prototype.addData.call(this, val);
        this.dataChange.emit(this.toGeoJSON());
        return this;
    };
    Object.defineProperty(GeoJSONDirective.prototype, "data", {
        get: function () {
            return this.toGeoJSON();
        },
        set: function (val) {
            this.setData(val);
        },
        enumerable: true,
        configurable: true
    });
    GeoJSONDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: 'yaga-geojson',
                },] },
    ];
    /** @nocollapse */
    GeoJSONDirective.ctorParameters = function () { return [
        { type: map_component_1.MapComponent, decorators: [{ type: core_1.Inject, args: [core_1.forwardRef(function () { return map_component_1.MapComponent; }),] },] },
    ]; };
    GeoJSONDirective.propDecorators = {
        'dataChange': [{ type: core_1.Output },],
        'addEvent': [{ type: core_1.Output, args: ['add',] },],
        'removeEvent': [{ type: core_1.Output, args: ['remove',] },],
        'popupopenEvent': [{ type: core_1.Output, args: ['popupopen',] },],
        'popupcloseEvent': [{ type: core_1.Output, args: ['popupclose',] },],
        'tooltipopenEvent': [{ type: core_1.Output, args: ['tooltipopen',] },],
        'tooltipcloseEvent': [{ type: core_1.Output, args: ['tooltipclose',] },],
        'clickEvent': [{ type: core_1.Output, args: ['click',] },],
        'dbclickEvent': [{ type: core_1.Output, args: ['dbclick',] },],
        'mousedownEvent': [{ type: core_1.Output, args: ['mousedown',] },],
        'mouseoverEvent': [{ type: core_1.Output, args: ['mouseover',] },],
        'mouseoutEvent': [{ type: core_1.Output, args: ['mouseout',] },],
        'contextmenuEvent': [{ type: core_1.Output, args: ['contextmenu',] },],
        'onEachFeatureEvent': [{ type: core_1.Output, args: ['onEachFeature',] },],
        'popupDirective': [{ type: core_1.Optional }, { type: core_1.ContentChild, args: [popup_directive_1.PopupDirective,] },],
        'tooltipDirective': [{ type: core_1.Optional }, { type: core_1.ContentChild, args: [tooltip_directive_1.TooltipDirective,] },],
        'data': [{ type: core_1.Input },],
    };
    return GeoJSONDirective;
}(leaflet_1.GeoJSON));
exports.GeoJSONDirective = GeoJSONDirective;
//# sourceMappingURL=geojson.directive.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/node_modules/@yaga/leaflet-ng2/lib/geojson.directive.js
// module id = ../../../../@yaga/leaflet-ng2/lib/geojson.directive.js
// module chunks = vendor